<template>
  <div id="storeInspectionEdit">
    <div class="commonContainer">
      <p class="title">{{ inspectionTitle }}{{$t('storeInspection.inspection')}}</p>
      <el-form :model="ruleForm" label-width="120px">
        <el-form-item label="门店编号:" prop="posId">
          <el-input v-model="ruleForm.posId" maxlength="6"
             @input="handleInputStoreName" :placeholder="$t('enter')"></el-input>
        </el-form-item>

        <el-form-item :label="$t('filters.doorName')" prop="doorName">
          <el-input v-model="ruleForm.doorName" readonly :placeholder="$t('enter')"></el-input>
        </el-form-item>

        <el-form-item :label="$t('storeInspection.storeType')" >
          <el-select v-model="ruleForm.type" :placeholder="$t('storeInspection.chooseType')" style="width: 100%">
            <el-option
              v-for="item in typeOptions"
              :key="item.itemKey"
              :label="item.itemValue"
              :value="item.itemKey">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('storeInspection.inspectionDate')"  prop="createDate">
          <el-date-picker
            style="width: 100%"
            v-model="ruleForm.createDate"
            type="date"
            value-format="yyyy-MM-dd"
            :placeholder="$t('choose')">
          </el-date-picker>
        </el-form-item>

        <el-form-item :label="$t('storeInspection.chanceDesc')" prop="content">
          <el-input rows="4" type="textarea" v-model="ruleForm.content" :placeholder="$t('enter')"></el-input>
        </el-form-item>

        <el-form-item :label="$t('survey.pic')" prop="images">
          <el-upload
            :action="attachmentsUploadUrl"
            :file-list="ruleForm.images"
            list-type="picture-card"
            :on-remove="handleRemove"
            :headers="myHeaders"
            :limit="5"
            :data="{type: 5}"
            :on-success="handleUploadSuccess"
            accept=".png,.jpg"
            :class="{ 'hide-upload': ruleForm.images.length >= 5 }"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <span class="tip">支持jpg,png,最多可添加5张图片</span>
        </el-form-item>
      </el-form>

      <el-row type="flex" class="row-bg" justify="space-around" style="margin-top: 50px">
        <el-col :span="6">
          <div class="center">
            <el-button type="plain" @click="goBack">{{ $t('close') }}</el-button>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="center">
            <el-button type="primary" @click="save(false)">{{ $t('save') }}</el-button>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="center">
            <el-button type="primary" @click="save(true)">{{ $t('storeInspection.createSuccess') }}</el-button>
            <br>
            <span class="tip">
                {{ $t('storeInspection.createTip') }}
            </span>
          </div>
        </el-col>
      </el-row>

    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import anyImageUpload from "@/components/anyImageUpload";

export default {
  name: 'storeInspectionEdit',
  components: {
    anyImageUpload
  },
  data: function () {
    return {
      myHeaders: {
        token: CookieManage.get('token') || '', // 用户token
      },
      attachmentsUploadUrl: window.uploadUrl,
      id: this.$route.query.id || null,
      initRuleForm: {
        inspectionTime: '', //巡店时间
        type: '', //巡店类型
        posId: '',
        doorName: '',
        content: '', //机会点描述
        images: []
      },
      ruleForm: {
        images: []
      },
      loading: false,
      formLabelWidth: '120px',
      typeOptions: [
        {
          itemKey: 1,
          itemValue: 'assortment产品'
        },
        {
          itemKey: 2,
          itemValue: 'service服务'
        },
        {
          itemKey: 3,
          itemValue: 'enviroment环境'
        },
        {
          itemKey: 4,
          itemValue: 'story telling故事演绎'
        },
      ],
      inspectionTitle: '',
    }
  },
  async mounted () {
    if (this.id == null) {
      this.inspectionTitle = "新增";
      this.ruleForm = _.cloneDeep(this.initRuleForm)
    } else {
      this.inspectionTitle = "编辑";
      await this.getData()
    }
  },

  methods: {

    handleInputStoreName() {
      if (this.ruleForm.posId.length === 6) {
        this.getDoorNameByPosid(this.ruleForm.posId)
      }else{
        this.ruleForm.doorName = ""
      }
    },
    async getDoorNameByPosid(posId){
      let param = {
        posId: posId
      }
      let res = await window.instance.post(topdoorReqUrl + '/door/list', param)
      res = res.data
      if (res.code === 200) {
        if(res.data.doors!=null && res.data.doors.length>0){
          this.ruleForm.doorName = res.data.doors[0].doorName
          this.ruleForm.doorNo = res.data.doors[0].doorNo
        }
      }
    },

    handleRemove(index, file){
      // this.ruleForm.images.onRemove
      console.log('.......index....',  index)
      console.log('.....file....', file)
      console.log('.....当前images....', this.ruleForm.images)
      this.ruleForm.images = file
    },
    handleUploadSuccess(res, file) {
      let imgUrl = file.response.data.url
      console.log('imgUrl', imgUrl)
      this.ruleForm.images.push(
        {
          name: '',
          url: imgUrl
        }
      );
    },

    // 编辑获取详情
    async getData(id) {
      let res = await window.instance.post(topdoorReqUrl + '/inspection/detail/' + this.id)
      res = res.data
      if (res.code === 200) {
        this.ruleForm = _.cloneDeep(res.data)

        // 获取图片列表的代码
        const fileList = []
        _.each(this.ruleForm.images, (img) => {
          fileList.push({
            name: '',
            url: img
          })
        })
        this.ruleForm.images = fileList
        this.ruleForm.createDate = this.ruleForm.createDate.replace(/\//g, '-')
      }
    },

    // 保存 true为创建,false为保存
    async save(type){
      /*if (this.ruleForm.everydayStartTime) {
        this.ruleForm.everydayStartTime = _.toString(new Date(this.ruleForm.everydayStartTime)).split(' ')[4];
      }*/
      const submitData = _.cloneDeep(this.ruleForm)
      const fileList = []
      _.each(this.ruleForm.images, (img) => {
        fileList.push(img.url)
      })
      submitData.images = fileList
      submitData.isCreateFinished = type
      //submitData.createDate = submitData.createDate
      console.log('submitData', submitData)
      //return
      let res = await window.instance.post(topdoorReqUrl + '/inspection/save', submitData);
      res = res.data
      if (res.code === 200) {
        this.$message.success(res.message)
        window.close()
      }else{
        this.$message.warning(res.message)
      }
    },


    goBack() {
      window.close()
    },
  }
}
</script>

<style>
.hide-upload .el-upload--picture-card {
  display: none;
}
.el-upload-list__item {
  transition: none !important; /* 完全禁用过渡效果 */
}
</style>
<style scoped lang="sass">
#storeInspectionEdit
  .center
    text-align: center
  .tip
    color: red
    display: inline-block
    margin-top: 10px
  .title
    font-size: 16px
    margin-bottom: 40px

</style>



// WEBPACK FOOTER //
// src/pages/storeInspection/storeInspectionEdit.vue